module.exports = __webpack_public_path__ + "img/POSITANO.10156d68.png";